import { client } from '../client';
import { IGMConversationParticipant } from './types/IGMConversationParticipant';
import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';

export const getParticipant = async (
  sid: string,
  participant_sid: string,
  userRole?: string,
): Promise<IGMConversationParticipant> => {
  const prefix = getStaffScopedApiPrefix(userRole);
  const { data } = await client.get(`${prefix}/conversations/${sid}/participants/${participant_sid}`);

  return data;
};
